export const PLACEHOLDER = '****************************************************************';
